import Vue from 'vue'
export default {
  data () {
    return {
      items: [], // Items is forced to be a data object here (Dont ever make items a computed, it breaks sorting)
      // as computed properties arent generally written to
      selected: {},
      tempIDcounter: 0, // counter
      page: 0,
      rowsPerPage: 10,
      searchIndex: 0,
      sortIndex: 0,
      sortAscending: false,
      sortLive: false,
      searchMode: false,
      searchText: '',
      ordering: 'ordering',
      // lets gradually implement filters instead of the other garbage :)
      filters: {
        rowsPerPage: 5,
        sortCol: 'name',
        sortAscending: true,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      }
    }
  },
  computed: {
    vuetifyPaginationPage: {
      get () {
        return this.page + 1
      },
      set (nv) {
        this.page = nv - 1
      }
    },
    filteredItems () {
      return this.filter(this.items)
    },
    sortedItems () {
      if (this.sortLive) {
        this.sort(this.filteredItems)
      }
      return this.filteredItems
    },
    searchMatches () {
      return this.search(this.sortedItems)
    },
    paginatedArray () {
      var index = (this.page) * this.rowsPerPage
      return this.searchMatches.slice(index, index + this.rowsPerPage)
    },
    selectedCount () {
      return Object.values(this.selected).reduce((a, i) => a + (i === true), 0)
    },
    entirePageIsSelected () {
      for (var item of this.paginatedArray) {
        if (this.selected[item.tempID] !== true) {
          return false
        }
      }
      return true
    },
    paginationLength () {
      return Math.ceil(this.searchMatches.length / this.rowsPerPage)
    }
  },
  watch: {
    rowsPerPage (nv) {
      if (!isNaN(nv) && nv > 0) {
        this.rowsPerPage = parseInt(nv)
        // e.g. if your on page 2 but now theres only max 1 page reset page to max possible
        if (this.page >= this.paginationLength) {
          this.page = this.paginationLength - 1
        }
      }
    },
    items: {
      immediate: true,
      handler (nv) {
        this.generateIdsAndOrdering()
        this.checkIfPageIsStillValid() // like after a delete
      }
    },
    searchMatches (nv) {
      // set searchText to a String (clearable text views set it to null)
      /* if (nv === null) {
        this.searchText = ''
      } */
      this.checkIfPageIsStillValid()
    },
    searchMode (nv) {
      this.searchText = ''
    },
    sortIndex (nv) {
      this.page = 0
      this.sort(this.items)
    },
    filters: {
      deep: true,
      handler (nv) {
        this.page = 0
        this.sort(this.items)
      }
    }
  },
  methods: {
    goToFirstPage () {
      this.page = 0
    },
    goToLastPage () {
      this.page = this.paginationLength - 1
    },
    goToNextPage () {
      this.page ++
    },
    goToPreviousPage () {
      this.page --
    },
    updatePageNumber (newPageNumber) {
      var newPage = newPageNumber
      if (!Number.isInteger(newPage)) {
        newPage = 0
      } else if (newPage < 0) {
        newPage = 0
      } else if (newPage > this.paginationLength - 1) {
        newPage = this.paginationLength - 1
      }

      this.page = parseInt(newPage)
    },
    checkIfPageIsStillValid () {
      var lastPage = Math.ceil(this.searchMatches.length / this.rowsPerPage)
      if (lastPage > 0) {
        lastPage--
      }

      if (lastPage >= 0 && lastPage < this.page) {
        this.page = lastPage
      }
    },
    checkRow (item) {
      Vue.set(this.selected, item.tempID, !this.selected[item.tempID])
    },
    filter (items) {
      return items
    },
    sort (items) {
      return items
    },
    resort () {
      // use this to manually sort (like in productions on quantity update) when not using sortLive
      this.sort(this.items)
    },
    search (items) {
      return items
    },
    clickSortHeader (column) {
      if (this.filters.sortCol !== column) {
        this.filters.sortAscending = false
      } else {
        this.filters.sortAscending = !this.filters.sortAscending
      }
      this.filters.sortCol = column
    },
    generateIdsAndOrdering () {
      var hstart = performance.now()
      if (this.items.length !== this.lastTrackedLocalItemsSize) {
        // Array has experienced an addition or delete
        if (this.ordering !== null) {
          this.items.sort((a, b) => a[this.ordering] - b[this.ordering])
          for (const [index, item] of this.items.entries()) {
            item[this.ordering] = index
          }
          this.sort(this.items)
        }
      }
      this.lastTrackedLocalItemsSize = this.items.length
      // generate tempID
      this.items.map(item => {
        if (!item.tempID) {
          item.tempID = this.getNewID()
        }
      })
      var hrend = performance.now()
    },
    getNewID () {
      this.tempIDcounter++
      return this.tempIDcounter
    },
    getSelectedRows () {
      // get
      return Object.entries(this.selected).reduce((a, i) => {
        if (i[1]) {
          a.push(this.items.find(item => item.tempID === parseInt(i[0])))
        }
        return a
      }, [])
    },
    onSuccessfullDelete () {
      this.selected = {}
    },
    selectAll () {
      for (var item of this.items) {
        Vue.set(this.selected, item.tempID, true)
      }
    },
    selectPage () {
      for (var item of this.paginatedArray) {
        Vue.set(this.selected, item.tempID, true)
      }
    },
    selectNone () {
      this.selected = {}
    },
    // Use this only in dragging components
    dragChange (event) {
      if (event.moved) {
        // this was the old way, leaving it here incase its needed in future
        /* var firstIndexOnPage = this.page * this.rowsPerPage
        this.items.splice(firstIndexOnPage, this.rowsPerPage, ...this.paginatedArray)
        for (const [index, item] of this.items.entries()) {
          item[this.ordering] = this.sortAscending ? (this.items.length - 1 - index) : index
        } */

        var orderingArray = this.paginatedArray.map(item => item[this.ordering])
        orderingArray.sort((a, b) => this.sortAscending ? b - a : a - b)
        for (const [index, item] of this.paginatedArray.entries()) {
          item[this.ordering] = orderingArray[index]
        }
        // this.sort(this.items)
        // above didnt work for updating a text view with item.ordering so brute force is below
        this.items.sort((a, b) => a.ordering - b.ordering)
      }
    }
  }
}
